import request from '@/utils/request'
import URL from '../urlTranslator'

export function queryLatestState(sendJobNo) {
  return request({
    url: URL.booking.queryLatestState,
    method: 'get',
    params: { sendJobNo }
  })
}

export function isRejectedBySendJobNo(sendJobNo, relateTenantId) {
  return request({
    url: URL.booking.isRejectedBySendJobNo,
    method: 'get',
    params: { sendJobNo, relateTenantId }
  })
}

export function isCrossed(sendJobNo, relateTenantId) {
  return request({
    url: URL.booking.isCrossed,
    method: 'get',
    params: { sendJobNo, relateTenantId }
  })
}

